module.exports = __webpack_public_path__ + "media/images/screenshot-20cb968f080abc91aa921fbdd8c7e00d.png";